import { REDUCER_KEY } from './reducer';

export const getVehiclesStore = (state) => state[REDUCER_KEY];
export const getVehiclesById = (state) => getVehiclesStore(state).resourcesById;
export const getVehiclesIsLoading = (state) => getVehiclesStore(state).isLoading;
export const getLastSyncDate = (state) => getVehiclesStore(state).lastSyncDate;
